import type React from 'react';
import type { Editor } from 'slate';
import filestack from '@atlas/tool/box/file/filestack';
import fileResponseToUploadedAttachment from '@atlas/tool/box/file/fileResponseToUploadedAttachment';
import type { TAttachment } from '@atlas/tool/box/file/types';

export default function withAttachments(
    editor: Editor,
    setAttachments: React.Dispatch<React.SetStateAction<TAttachment[]>>,
    onLoadStateChange: React.Dispatch<React.SetStateAction<number>>,
    onError: (error: string) => void,
    filter?: (file: File) => boolean,
): Editor {
    const { insertData } = editor;

    editor.insertData = (data) => {
        const html = data.getData('text/html');

        if (html) {
            return insertData(data);
        }

        const { files } = data;
        if (!files || !files.length) return insertData(data);

        const filteredFiles = filter ? Array.from(files).filter(filter) : Array.from(files);

        onLoadStateChange((n) => n + filteredFiles.length);
        Array.from(filteredFiles).forEach((file) => {
            filestack()
                .then((client) =>
                    client
                        .upload(file, {}) // The version 3.33.3 fails without the second argument
                        .then(fileResponseToUploadedAttachment)
                        .then((uploadedFile) => {
                            setAttachments((list) => list.concat(uploadedFile));
                        }),
                )
                .catch(() => onError(`Failed to upload "${file.name}"`))
                .finally(() => onLoadStateChange((n) => n - 1));
        });

        if (filteredFiles.length >= files.length) return;

        const newData = new DataTransfer();
        Array.from(files).forEach((file) => filteredFiles.includes(file) || newData.items.add(file));

        return insertData(newData);
    };

    return editor;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withConstants', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
